export default {"src":"/_next/static/media/applepodcast-ico.431f5a29.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};